module.exports = __webpack_public_path__ + "media/images/np-4a53cd75fe1da0bf4ceab20bd4bf11ff.png";